module.exports = __webpack_public_path__ + "img/brand@2x.8447a565.png";